import first from 'lodash/fp/first';
import { PARTNER_LIST } from '../constants/theme';

export const getSubdomain = (host: string) => first(host.split('.')) || '';

export const resolvePartner = (subdomain: string) =>
  PARTNER_LIST.includes(subdomain);
